export default (Alpine) => {
  Alpine.magic("truncate", () => (str, length) => _.truncate(str, { length: length }));
};
